import { useMediaQuery } from "@vueuse/core";
const breakpoints = {
    desktop: 1270,
    desktop_md: 1024,
    tablet: 640,
    mobile: 393,
}

// Nuxt 3 內建的 media query composable，SSR / hydration 安全
export const useBreakpoint = (breakpoint = "desktop") => {
    return useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`);
}

// 統一的螢幕尺寸
export const useScreenSize = () => {
    const isDesktop = useBreakpoint('desktop');
    const isTablet = useBreakpoint('tablet');
    
    return computed(() => {
        if (isDesktop.value) return 'lg';
        if (isTablet.value) return 'md';
        return 'sm';
    });
}